import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IoIosPlay, IoIosPause } from 'react-icons/io';
import { FiDownload } from 'react-icons/fi';
import { Button, Text, Flex, Box } from 'rebass';
import { useWindowSize } from 'react-use';

import VideoPreviewTime from 'collections/watch-me-grow/components/Trimmer/VideoPreviewTime';
import PreviewSlider from './PreviewSlider';
import Grid from 'app/grid/index';

export function CircleButton(props) {
  return (
    <Button
      p={0}
      type="button"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        outline: 'none',
      }}
      bg="purples.7"
      {...props}
    />
  );
}

function PreviewControls({
  isPlaying,
  currentSeconds,
  endSeconds,
  onPlayClick,
  onPauseClick,
  onSliderChange,
  disabled,
}) {

  const { width } = useWindowSize();
  const isMobile = width < 500;
  return (
    <Grid
      gridTemplateColumns={isMobile ? 'max-content 1fr max-content' : 'max-content 1fr max-content'}
      justifyContent="center"
      height={48}
      width="100%"
      alignItems="center"
    >

      <Flex alignItems="center" justifyContent="center" alignSelf="end" mr={isMobile ? 1 : 3}>
        {isPlaying ? (
          <CircleButton onClick={onPauseClick}>
            <Text color="white" size={18} as={IoIosPause} />
          </CircleButton>
        ) : (
          <CircleButton onClick={onPlayClick} type="button" disabled={disabled}>
            <Text color="white" size={18} as={IoIosPlay} />
          </CircleButton>
        )}
      </Flex>
      <Box>
        <Flex alignItems="center" justifyContent="space-between" mb="10px" mt="5px">
          <VideoPreviewTime seconds={currentSeconds} isMobile={isMobile} />
          <VideoPreviewTime seconds={endSeconds} isMobile={isMobile} />
        </Flex>
        <PreviewSlider
          value={currentSeconds}
          min={0}
          max={endSeconds}
          step={0.016}
          onChange={onSliderChange}
          onBeforeChange={onPauseClick}
          disabled={disabled}
        />
      </Box>
      {/* {celebration?.paid && showDownload && mediaDetails && !disabled && (
        <a
          href={`${mediaDetails['unprocessed-url']}?download=true`}
 
          download
        >
          <CircleButton alignSelf="end" ml={1} type="button">
            <Text color="white" size={18} as={FiDownload} />
          </CircleButton>
        </a>
      )} */}

    </Grid>
  );
}
PreviewControls.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  currentSeconds: PropTypes.number.isRequired,
  endSeconds: PropTypes.number.isRequired,
  onPlayClick: PropTypes.func.isRequired,
  onPauseClick: PropTypes.func.isRequired,
  onSliderChange: PropTypes.func.isRequired,
};

export default PreviewControls;
